interface Dependency {
    id: string;
    check: (() => boolean) | boolean;
}

export const isSecureContext: Dependency = {
    id: "isSecureContext",
    check: () => window.isSecureContext,
}
export const webCrypto: Dependency = {
    id: "webCrypto",
    check: () => typeof window.crypto === "object" && typeof window.crypto.subtle === "object" && typeof window.crypto.subtle.digest === "function",
}
export const broadcastChannel: Dependency = {
    id: "broadcastChannel",
    check: () => typeof BroadcastChannel === "function" && typeof BroadcastChannel.prototype.postMessage === "function",
}
export const abortController: Dependency = {
    id: "abortController",
    check: () => typeof AbortController === "function" && typeof AbortController.prototype.abort === "function",
}
export const bigInt: Dependency = {
    id: "bigInt",
    check: () => typeof BigInt === "function",
}
export const dataView: Dependency = {
    id: "dataView",
    check: () => typeof DataView === "function" && typeof DataView.prototype.setBigUint64 === "function",
}

export function checkDependencies() {
    for (const dep of [isSecureContext, abortController, webCrypto, broadcastChannel, bigInt, dataView]) {
        if (typeof dep.check === "function") {
            try {
                dep.check = dep.check();
            } catch (err) {
                console.error(`Dependency check failed for ${dep.id}:`, err);
                dep.check = false;
            }
        }
        if (!dep.check) {
            return dep.id
        }
    }
    return undefined;
}
